<template>
  <section class="hero is-fullheight print-proof-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-10">

            <div v-if="loading" class="has-text-centered">
              <p>Ladataan...</p>
            </div>

            <div v-else-if="error" class="has-text-centered">
              <h2 class="title is-4">Vedosta ei löytynyt</h2>
              <p>Tarkista linkki ja yritä uudelleen.</p>
            </div>

            <div v-else>
              <h2 class="subtitle is-5 has-text-centered" v-if="design.product_name">
                {{ design.product_name }}
              </h2>

              <!-- 3D Preview -->
              <div class="box" v-if="viewerTextures.length > 0">
                <h3 class="title is-5">3D Esikatselu</h3>
                <CandyBoxViewer :glbPath="glbPath" :textures="viewerTextures" />
              </div>

              <!-- PDF -->
              <div class="box" v-if="design.pdf_url">
                <h3 class="title is-5">Painovalmis PDF</h3>
                <div class="pdf-embed">
                  <iframe :src="design.pdf_url" width="100%" height="600px" frameborder="0"></iframe>
                </div>
                <div class="has-text-centered mt-4">
                  <a :href="design.pdf_url" target="_blank" class="button is-primary">
                    Lataa PDF
                  </a>
                </div>
              </div>

              <div v-if="!design.pdf_url" class="has-text-centered">
                <p>PDF ei ole vielä valmis. Yritä hetken kuluttua uudelleen.</p>
              </div>

              <p class="has-text-centered has-text-grey mt-4" v-if="design.created">
                Luotu: {{ formatDate(design.created) }}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import axios from 'axios'
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import CandyBoxViewer from '../3d/CandyBoxViewer.vue'

export default {
  name: 'PrintProofPage',
  components: { PmNavbar, PmFooter, CandyBoxViewer },
  data() {
    return {
      design: {},
      loading: true,
      error: false,
    }
  },
  computed: {
    glbPath() {
      const glb = this.design.editor_config?.glb_path
      if (glb) {
        return `${process.env.BASE_URL}${glb}`
      }
      return ''
    },
    viewerTextures() {
      const sides = this.design.editor_config?.sides
      const urls = this.design.side_image_urls
      if (!sides || !urls) return []

      const textures = sides
        .filter(side => urls[`side_${side.name}`])
        .map(side => ({
          gblVariable: side.glb_variable,
          texture: {
            dataUrl: urls[`side_${side.name}`],
            width: side.width,
            height: side.height,
            rotate: side.texture_rotate || 0,
          }
        }))

      // Add fixed bottom texture (ingredients) if configured
      const bottomTex = this.design.editor_config?.fixed_bottom_texture
      if (bottomTex) {
        textures.push({
          gblVariable: 'Bottom',
          texture: {
            dataUrl: `${process.env.BASE_URL}${bottomTex}`,
            posx: 0,
            posy: 0,
            width: 555,
            height: 177,
            rotate: 0,
          }
        })
      }

      return textures
    }
  },
  mounted() {
    this.fetchProof()
  },
  methods: {
    fetchProof() {
      const token = this.$route.params.token
      axios.get(`${process.env.VUE_APP_PM_BACKEND_URL}/api/v1/print-proof/${token}/`)
        .then((res) => {
          this.design = res.data
          this.loading = false
        })
        .catch(() => {
          this.error = true
          this.loading = false
        })
    },
    formatDate(dateStr) {
      const d = new Date(dateStr)
      return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`
    }
  }
}
</script>

<style scoped lang="scss">
.print-proof-page {
  .pdf-embed {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
  }
  .box {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
}
</style>
